<template>
  <div class="share">
    <title>微云腾案例分享|企业建站|logo设计|网站维护|平面设计|网站推广</title>
    <meta name="keywords" content="深圳市微云腾科技有限公司,专业建站,模板定制建站,全定制建站,logo设计,平面设计">
    <!-- 案例第一部分 -->
    <div class="sfirst">
      <img src="../assets/share/share.png" alt class="syy" />
      <div class="sbgc"></div>
      <div class="sdbyy"></div>
      <div class="sbig">
        <div class="contaniner">
          <div class="snav">
            <Navbar></Navbar>
          </div>
          <div class="sneirong">
            <div class="sleft">
              <p>SHARE</p>
              <p style="color:#24C0EA;font-size:20px; width:100px;">案例分享</p>
            </div>
            <div class="sright">
              <span>
                <p>我们坚信：“品牌”不仅仅是一个商标，一件产品种品质，它用良好的质量维系消费者对企业的信赖。</p>
              </span>
              <p>我们将针对不同行业客户应用互联网的差异化特征，在产品即服务的战略思想指导下，针对各个行业提供了定制化的行业网站建设解决方案服务模式。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 案例第二部分 -->
    <div class="shsecond">
      <div class="shbgc"></div>
      <div class="shneirong">
        <div class="contaniner">
          <div class="shzwm">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="网站建设" name="first">
                <div class="shwz">
                  <div class="shzuo">
                    <img src="../assets/share/1.gif" alt class="shf" />
                  </div>
                  <ul class="shyou">
                    <li>
                      <img src="../assets/share/2.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/3.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/4.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/5.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/6.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/7.gif" alt />
                    </li>
                  </ul>
                </div>
                 <!-- 案例图下部分 -->
                <div class="shxwz">
                  <div class="shxyou">
                    <img src="../assets/share/1.gif" alt class="shxf" />
                  </div>
                  <ul class="shxzuo">
                    <li>
                      <img src="../assets/share/2.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/3.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/4.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/5.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/6.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/7.gif" alt />
                    </li>
                  </ul>
                </div>
              </el-tab-pane>
              <el-tab-pane label="品牌设计" name="second">
                <div class="shwz">
                  <div class="shzuo">
                    <img src="../assets/share/1.gif" alt class="shf" />
                  </div>
                  <ul class="shyou">
                    <li>
                      <img src="../assets/share/2.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/3.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/4.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/5.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/6.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/7.gif" alt />
                    </li>
                  </ul>
                </div>
                <!-- 案例图下部分 -->
                <div class="shxwz">
                  <div class="shxyou">
                    <img src="../assets/share/1.gif" alt class="shxf" />
                  </div>
                  <ul class="shxzuo">
                    <li>
                      <img src="../assets/share/2.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/3.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/4.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/5.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/6.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/7.gif" alt />
                    </li>
                  </ul>
                </div>
              </el-tab-pane>
              <el-tab-pane label="平面设计" name="third">
                <div class="shwz">
                  <div class="shzuo">
                    <img src="../assets/share/1.gif" alt class="shf" />
                  </div>
                  <ul class="shyou">
                    <li>
                      <img src="../assets/share/2.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/3.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/4.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/5.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/6.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/7.gif" alt />
                    </li>
                  </ul>
                </div>
                 <!-- 案例图下部分 -->
                <div class="shxwz">
                  <div class="shxyou">
                    <img src="../assets/share/1.gif" alt class="shxf" />
                  </div>
                  <ul class="shxzuo">
                    <li>
                      <img src="../assets/share/2.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/3.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/4.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/5.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/6.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/7.gif" alt />
                    </li>
                  </ul>
                </div>
              </el-tab-pane>
              <el-tab-pane label="UI设计" name="fourth">
                <div class="shwz">
                  <div class="shzuo">
                    <img src="../assets/share/1.gif" alt class="shf" />
                  </div>
                  <ul class="shyou">
                    <li>
                      <img src="../assets/share/2.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/3.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/4.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/5.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/6.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/7.gif" alt />
                    </li>
                  </ul>
                </div>
                 <!-- 案例图下部分 -->
                <div class="shxwz">
                  <div class="shxyou">
                    <img src="../assets/share/1.gif" alt class="shxf" />
                  </div>
                  <ul class="shxzuo">
                    <li>
                      <img src="../assets/share/2.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/3.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/4.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/5.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/6.gif" alt />
                    </li>
                    <li>
                      <img src="../assets/share/7.gif" alt />
                    </li>
                  </ul>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="shmore">
            <p>
              .
              .
              .
            </p>
          </div>
        </div>
      </div>
    </div>
     <!-- 底部 -->
      <div class="shfoot">
        <Footer></Footer>
      </div>
  </div>
</template>
<style lang="scss" scope>
.share {
  .contaniner {
    width: 1200px;
    margin: 0 auto;
  }
  //   案例第一部分
  .sfirst {
    width: 100%;
    height: 844px;
    position: relative;
    .syy {
      width: 100%;
      height: 844px;
      filter: blur(1px);
    }
    .sbgc {
      width: 100%;
      height: 844px;
      background-color: #000;
      opacity: 0.5;
      position: absolute;
      top: 0;
    }
    .sdbyy {
      width: 100%;
      height: 350px;
      background-color: #000;
      opacity: 0.5;
      position: absolute;
      bottom: 0;
    }
    .sbig {
      width: 100%;
      height: 844px;
      position: absolute;
      top: 0;
      .snav {
        width: 100%;
        height: 100px;
      }
      .sneirong {
        width: 100%;
        height: 210px;
        margin-top: 464px;
        .sleft {
          width: 228px;
          height: 130px;
          font-size: 48px;
          color: #bbbbbb;
          float: left;
        }
        .sright {
          width: 760px;
          height: 210px;
          float: right;
          span {
            display: block;
            width: 100%;
            height: 125px;
            color: #bbbbbb;
          }
          p {
            color: #bbbbbb;
          }
        }
      }
    }
  }
  //   案例第二部分
  .shsecond {
    width: 100%;
    height: 1350px;
    position: relative;
    .shbgc {
      width: 100%;
      height: 1350px;
      background-color: #111111;
      position: absolute;
      top: 0;
    }
    .shneirong {
      width: 100%;
      height: 1350px;
      position: absolute;
      top: 0;
      .shzwm {
        width: 100%;
        // width: 800px;
        // height: 250px;
        margin: 0 auto;
        color: #bbbbbb;
        text-align: center;
        margin-top: 30px;
        margin-bottom: 60px;
        // 案例上部分
        .shwz {
          // width: 606px;
          width: 100%;
          // height: 210px;
          // margin: 0 auto;
          overflow: hidden;
          .shzuo {
            // width: 200px;
            width: 40%;
            height: 540px;
            float: left;
            .shf {
              width: 100%;
              height: 540px;
            }
          }
          .shyou {
            list-style: none;
            float: right;
            // width: 406px;
            width: 60%;
            height: 540px;
            li {
              float: left;
              width: 240px;
              height: 270px;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
        // 案例下部分
        .shxwz{
          width: 100%;
          .shxyou{
            width: 40%;
            height: 540px;
            float: right;
            .shxf{
              width: 480px;
              height: 540px;
            }
          }
          .shxzuo{
            width: 60%;
            height: 540px;
            list-style: none;
            float: left;
            li{
              width: 240px;
              height: 270px;
              float: left;
              img{
                width: 240px;
                height: 270px;
              }
            }
          }
        }
      }
      .shmore{
        width: 50px;
        height: 30px;
        margin: 0 auto;
        color: #BBBBBB;
      }
    }
  }
}
</style>
<style lang="scss">
.el-tabs__item.is-active {
  color: #409eff !important;
}
.el-tabs__item {
  width: 75px;
  color: #bbbbbb !important;
  padding: 0 !important;
  margin: 0 50px;
  font-size: 18px;
}
// 去掉底下白线的
.el-tabs__nav-wrap::after {
  display: none !important;
}
// 去掉底下蓝线的
.el-tabs__active-bar {
  display: none !important;
}
#tab-first {
  margin-left: 300px;
}
// 四个tab的下边距
.el-tabs__header {
  margin-bottom: 60px !important;
}
</style>
<script>
import Navbar from "../components/Navbar";
import Footer from "../components/Footer"
export default {
  data() {
    return {
      activeName: "first"
    };
  },
  methods: {},
  components: {
    Navbar,
    Footer
  }
};
</script>